module.exports = __webpack_public_path__ + "97529197ffd36b9e38617afd7dd66c81.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextCompPro-Medium.ttf
// module id = 45
// module chunks = 0